/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Row, Col, Form, Input, Select, Button, message, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";

import {
  capitalise,
  capitalize,
  checkAlphabets,
  checkNumbervalue,
  checkSpace,
  checkSpecialCharacter,
} from "../../../utils";

import {
  getSingleOnboarededVehicle,
  getSingleOnboarededVehicleClear,
  onboardVehicle,
  onboardVehicleClear,
  updateOnboardedVehicle,
  updateOnboardedVehicleClear,
} from "../../../actionsMethods/cashBookingMethods";
import axios from "axios";
import { APIs, getToken } from "../../../utils/worker";

const createVehicle = ({
  type,
  vehicleNo,
  activeKey,
  handleSuccess = () => {},
  handleEdit = () => {},
}) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const history = useLocation();

  const [loading, setLoading] = useState(false);

  const [getVehicleData, setGetVehicleData] = useState();
  const [editView, setEditView] = useState();
  const typeData = [
    {
      value: "2",
      key: "2",
      label: "2",
    },
    {
      value: "4",
      key: "4",
      label: "4",
    },
    {
      value: "6",
      key: "6",
      label: "6",
    },
  ];
  const permitTypeData = [
    {
      value: "National",
      key: "National",
      label: "National",
    },
    {
      value: "State",
      key: "State",
      label: "State",
    },
  ];

  const OwnershipTypeData = [
    {
      value: " Own",
      key: " Own",
      label: " Own",
    },
    {
      value: "Co-loader",
      key: "Co-loader",
      label: "Co-loader",
    },
  ];

  useEffect(() => {
    if (type !== undefined) {
      setEditView(type);
    }
    form.resetFields();
  }, [activeKey]);

  const updateOnboardedVehicleResponse = useSelector(
    (state) => state.appReducer.updateOnboardedVehicleReducer,
    shallowEqual
  );

  const getSingleOnboarededVehicleResponse = useSelector(
    (state) => state.appReducer.getSingleOnboarededVehicleReducer,
    shallowEqual
  );

  const onboardVehicleResponse = useSelector(
    (state) => state.appReducer.onboardVehicleReducer,
    shallowEqual
  );

  const {
    fetching: registerFetching,
    result: registerResult,
    error: registerError,
  } = onboardVehicleResponse;

  const {
    fetching: updateFetching,
    result: updateResult,
    error: updateError,
  } = updateOnboardedVehicleResponse;

  const {
    fetching: singleFetching,
    result: singleResult,
    error: singleError,
  } = getSingleOnboarededVehicleResponse;

  useEffect(() => {
    dispatch(getSingleOnboarededVehicleClear());
  }, [history.pathname]);

  useEffect(() => {
    if (getVehicleData !== undefined) {
      form.setFieldsValue({
        ownership: getVehicleData?.ownership,
        loadCapacity: getVehicleData?.loadCapacity,
        permitType: getVehicleData?.permitType,
        vehicleNo: getVehicleData?.vehicleNo,
        noOfWheels: getVehicleData?.noOfWheels,
        vehicleClass: getVehicleData?.vehicleClass,
        loadCapacityInTons: getVehicleData?.loadCapacityInTons,
      });
    }
  }, [getVehicleData]);

  useEffect(() => {
    if (updateResult !== null) {
      message.success(updateResult.message);
      dispatch(updateOnboardedVehicleClear());
      handleSuccess("2");
    }
    if (updateError !== null) {
      message.success(updateError?.message);
      dispatch(updateOnboardedVehicleClear());
    }
  }, [updateResult, updateError]);

  useEffect(() => {
    if (activeKey == "1" && vehicleNo !== undefined && vehicleNo?.length > 0) {
      dispatch(getSingleOnboarededVehicle(vehicleNo));
    }
  }, [activeKey, vehicleNo]);

  useEffect(() => {
    if (singleResult !== null) {
      setGetVehicleData(singleResult);
    }

    if (singleResult == null) {
      setGetVehicleData([]);
    }

    if (singleError !== null) {
      message.success(singleError?.message);
    }
  }, [singleResult, singleError, activeKey, vehicleNo]);

  useEffect(() => {
    if (registerResult !== null) {
      message.success("Vehicles Details are registered succesfully");
      dispatch(onboardVehicleClear());
      handleSuccess("2");
      form.resetFields();
    }
    if (registerError !== null) {
      message.error(registerError?.message);
      dispatch(onboardVehicleClear());
    }
  }, [registerResult, registerError]);

  const registerNewVehicle = (values) => {
    const payload = {
      vehicles: values,
    };
    delete values.loadCapacityInTons;
    dispatch(onboardVehicle(values));
  };

  const onUpdate = (values) => {
    let payload = {
      // vehicleClass: values.vehicleClass,
      ownership: values.ownership,
      // status: true,
      permitType: values.permitType,
    };
    dispatch(updateOnboardedVehicle(payload, values.vehicleNo));
  };

  const formProps = {
    name: "createVehicle",
    onFinish: editView == "edit" ? onUpdate : registerNewVehicle,
    autoComplete: "off",
  };

  const handleCancel = () => {
    if (editView === "edit") {
      handleEdit(null, "2");
    } else {
      setEditView(undefined);
      navigate("/onboarding-settings");
    }
    form.resetFields();
  };

  const handleTonne = (e) => {
    let num = (e?.target?.value / 1000)?.toString();
    form.setFieldValue("loadCapacityInTons", num);
  };

  const vehicleValidation = async (values) => {
    let token = getToken();
    try {
      let res = await axios.get(
        `${APIs.baseURL}/vehicle-service/v1/getDetails/fromGovn/${values}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (res.status === 200) {
        let getClassData = res.data.data.response.vehicle.category;
        let getWeight = res.data.data.response.vehicle.cubicCapacity;

        form.setFieldValue("vehicleClass", getClassData);
        form.setFieldValue("loadCapacity", getWeight);
        let num = (getWeight / 1000)?.toString();
        form.setFieldValue("loadCapacityInTons", num);
      }
    } catch (error) {
      form.setFieldValue("vehicleClass", null);
      form.setFieldValue("loadCapacity", null);
      form.setFieldValue("loadCapacityInTons", null);
      message.error("Invalid Number");
    }
  };

  return (
    <div className="master-main-container">
      <Spin
        spinning={
          loading || registerFetching || updateFetching || singleFetching
        }
      >
        <Form
          layout="vertical"
          className="global-form"
          form={form}
          {...formProps}
          scrollToFirstError={{
            behavior: "smooth",
            block: "center",
            inline: "center",
          }}
        >
          <Row
            className="pt-1 global-form-row vehicle-onboard-create-container"
            gutter={20}
          >
            <Col span={24} className="mb-1">
              <span className="master-title">
                {editView === "edit"
                  ? "Edit Vehicle Details"
                  : "Vehicle Details"}
              </span>
              <hr className="divider" />
            </Col>
            <Col span={12} className="mb-1">
              <Form.Item
                name="vehicleNo"
                label={"Vehicle number"}
                rules={[
                  {
                    required: true,
                    // pattern: /^([A-Z]{2}[0-9]{2}[A-Z]{1,2}[0-9]{4,6})$/g,
                    message: "Invalid vehicle number",
                    // validateTrigger: "onSubmit",
                  },
                ]}
                onKeyPress={(event) => {
                  if (checkSpecialCharacter(event) || checkSpace(event)) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  style={{ textTransform: "uppercase" }}
                  placeholder="Example:KA32F26222"
                  onBlur={(e) => {
                    form.setFieldValue(
                      "vehicleNo",
                      e.target.value.toUpperCase()
                    );
                  }}
                  disabled={editView === "edit"}
                  // onChange={(e) => {
                  //   // e.target.value = e.target.value.toUpperCase();
                  //   if (e.target.value.length >= 9) {
                  //     // vehicleValidation(e.target.value.toUpperCase());
                  //   } else {
                  //     form.setFieldValue("vehicleClass", null);
                  //     form.setFieldValue("loadCapacity", null);
                  //     form.setFieldValue("loadCapacityInTons", null);
                  //   }
                  // }}
                  maxLength={15}
                />
              </Form.Item>
            </Col>

            <Col span={12} className="mb-1">
              <Form.Item
                name="noOfWheels"
                label="Number of wheels"
                rules={[
                  {
                    required: true,
                    message: "Please select vehicle type",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Please select vehicle type"
                  options={typeData}
                  disabled={editView === "edit"}
                />
              </Form.Item>
            </Col>

            <Col span={12} className="mb-1">
              <Form.Item
                name="permitType"
                label="Permit type"
                rules={[
                  {
                    required: true,
                    message: "Please enter permit type",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Please select permit type"
                  options={permitTypeData}
                  // disabled={editView === "edit"}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="loadCapacity"
                label="Weight (kg)"
                // className="pr-1"
                rules={[
                  {
                    required: true,
                    message: "Enter weight",
                  },
                  () => ({
                    validator(rule, value = "") {
                      if (parseInt(value) === 0) {
                        return Promise.reject("Value should not be 0");
                      } else {
                        return Promise.resolve();
                      }
                    },
                    // validateTrigger: "onSubmit",
                  }),
                  {
                    pattern: /^\d{1,6}(\.\d{0,})?$/,
                    message: "Invalid format",
                  },
                ]}
              >
                <Input
                  placeholder="Enter weight"
                  // disabled={editView === "edit"}
                  maxLength={6}
                  onKeyPress={(event) => {
                    if (
                      checkNumbervalue(event) ||
                      checkSpace(event) ||
                      checkSpecialCharacter(event)
                    ) {
                      event.preventDefault();
                    }
                  }}
                  onChange={handleTonne}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="loadCapacityInTons" label="Weight (ton)">
                <Input
                  placeholder="Weight"
                  disabled={true}
                  maxLength={6}
                  onKeyPress={(event) => {
                    if (checkNumbervalue(event) || checkSpace(event)) {
                      event.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12} className="mb-1">
              <Form.Item
                name="vehicleClass"
                label={"Vehicle class"}
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <Input
                  placeholder="Enter vehicle class"
                  maxLength={30}
                  disabled={editView === "edit"}
                  // style={{ textTransform: "uppercase" }}
                  onBlur={(e) => {
                    form.setFieldValue(
                      "vehicleClass",
                      e.target.value.toUpperCase()
                    );
                  }}
                  // onKeyPress={(event) => {
                  //   if (checkSpecialCharacter(event) || checkAlphabets(event)) {
                  //     event.preventDefault();
                  //   }
                  // }}
                />
              </Form.Item>
            </Col>
            <Col span={12} className="mb-1">
              <Form.Item
                name="ownership"
                label="Ownership"
                rules={[
                  {
                    required: true,
                    message: "Please enter ownership",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Please select ownership"
                  options={OwnershipTypeData}
                  // disabled={editView === "edit"}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <hr className="divider m-0" />
            </Col>
            <Col span={24} className="flex-end p-1">
              <Button className="cancel-btn w-13" onClick={handleCancel}>
                CANCEL
              </Button>

              <Button htmlType="submit" className="save-btn ml-1 w-13">
                SAVE
              </Button>
            </Col>
          </Row>
        </Form>
      </Spin>
    </div>
  );
};

export default createVehicle;
